import { apiDelete, apiGet, apiPost, apiPut } from './http'
import { downloadBlobResponse, normalizeBuildingQuery } from './helpers'

export const findAll = async (params = {}) =>
  apiGet('/expense', {
    auth: true,
    config: { params: normalizeBuildingQuery(params) },
    fallbackMessage: 'Error al obtener los egresos.',
  })

export const findById = async id =>
  apiGet(`/expense/${id}`, {
    auth: true,
    fallbackMessage: 'Error al obtener el egreso.',
  })

export const create = async payload =>
  apiPost('/expense', payload, {
    auth: true,
    fallbackMessage: 'Error al crear el egreso.',
  })

export const update = async ({ id, ...payload }) =>
  apiPut(`/expense/${id}`, payload, {
    auth: true,
    fallbackMessage: 'Error al actualizar el egreso.',
  })

export const remove = async id =>
  apiDelete(`/expense/${id}`, {
    auth: true,
    fallbackMessage: 'Error al eliminar el egreso.',
  })

export const exportExcel = async (params = {}) => {
  const response = await apiGet('/expense/export/excel', {
    auth: true,
    rawResponse: true,
    config: {
      params: normalizeBuildingQuery(params),
      responseType: 'blob',
    },
    fallbackMessage: 'Error al exportar los egresos a Excel.',
  })

  if (!response || !response.data) return response

  downloadBlobResponse(response, params.fileName || 'egresos', 'xlsx')
  return { ok: true }
}

export const exportPdf = async (params = {}) => {
  const response = await apiGet('/expense/export/pdf', {
    auth: true,
    rawResponse: true,
    config: {
      params: normalizeBuildingQuery(params),
      responseType: 'blob',
    },
    fallbackMessage: 'Error al exportar los egresos a PDF.',
  })

  if (!response || !response.data) return response

  downloadBlobResponse(response, params.fileName || 'egresos', 'pdf')
  return { ok: true }
}
